// The first free row below every card. Uses the lowest bottom edge rather
// than the bottom of the lowest-starting card, which a taller card above it
// can extend past. Always measured against the authored layout (the one that's
// saved), never a narrow-screen reflow — canvasMode is kept for callers only.
const findStartingY = (cards: CanvasCard.Card[], canvasMode?: CanvasMode) =>
  cards.reduce((bottom, card) => {
    const { y, h } = card.layout;
    return Math.max(bottom, y + h);
  }, 0);

export default findStartingY;
